import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EuroIcon(props: IconProps) {
    return <Icon {...props} iconKey={"euro"}/>
}
